import React, { useEffect, useState } from 'react'
import { FaArrowRight } from 'react-icons/fa';

import { motion } from "motion/react"
import HomeSlider from '../Component/HomeSlider';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoies, getProduct, getSubCategoies } from '../redux/actions/action-creator';
import Product from './Product';
import Productslider from './Products/Productslider';
import { Col, Container, Row } from 'react-bootstrap';
import axiosInstance from '../api/axiosInstance';
import Button from '../Component/custombutton';
import Counter from '../Component/Counter';
import GlobalFootprintSection from '../Component/GlobalFootprintStats';
import TextBackground from '../Component/TextBackground';
import bgIMG from '../assets/imases/Air compressor 15 hp powerman.JPG';
import bgIMGA from '../assets/imases/Powermanstatic-removebg-preview.png';
import DOMPurify from 'dompurify';
import POWORMAIN from '../assets/imases/powerman.jpg';
import FloatingVideoAd from '../Component/FloatingVideoAd';
import shot1 from '../assets/video/shot1.mp4';
import GlobalFootprintStats from '../Component/GlobalFootprintStats';
import LogoSlider from '../Component/LogoSlider';
import POWORMAINSTATIC from '../assets/imases/Powermanstatic-removebg-preview.png';
import POWORMAINSTATIC2 from '../assets/imases/IMG_3136.PNG';
import POWORMAINSTATIC5 from '../assets/imases/IMG_3141.JPG';
import POWORMAINSTATIC4 from '../assets/imases/IMG_3139.JPG';
import POWORMAINSTATIC6 from '../assets/imases/powermanBenifit.JPG';
import HOMESTATIC_IMG1 from '../assets/imases/home_static_3.jpg';
import HOMESTATIC_IMG7 from '../assets/imases/home_static_7.jpg';
import HOMESTATIC_IMG8 from '../assets/imases/home_static_8.jpg';
import HOMESTATIC_IMG9 from '../assets/imases/home_static_9.jpg';

const Home = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const { categorylist = [], subcategorylist = [], productlist = [] } = useSelector(state => state.common);

    useEffect(() => {
        dispatch(getCategoies());
        dispatch(getSubCategoies());
        dispatch(getProduct());
    }, [dispatch]);


    // Function to clean Quill-specific attributes
    const cleanDescription = (html) => {
        if (!html) return '';
        return html
            .replace(/contenteditable="false"/g, '')
            .replace(/class="ql-ui"/g, '')
            .replace(/spellcheck="false"/g, '');
    };

    // Function to sanitize and render the description
    const renderDescription = (description) => {
        const cleanedDescription = cleanDescription(description);
        const sanitizedDescription = DOMPurify.sanitize(cleanedDescription);
        return (
            <div
                className="quill-content"
                dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
            />
        );
    };


    return (
        <>
            <HomeSlider />

            <div className='home_product'>
                <Container>
                    {productlist.length > 0 ? (
                        productlist.slice(0, 1).map((item, index) => {
                            const isEven = index % 2 === 0;
                            const imageCol = (
                                <Col key={`image-${item._id}`}>
                                    <div className='home_product_list_img'>
                                        <img
                                            src={`${axiosInstance.defaults.baseIMG}${item.image}`}
                                            alt={item.name}
                                        />
                                    </div>
                                </Col>
                            );
                            const contentCol = (
                                <Col key={`content-${item._id}`}>
                                    <div className='home_product_list_content'>
                                        <h3>{item.name.replace(/<\/?[^>]+(>|$)/g, "")}</h3>
                                        {renderDescription(item.description)}
                                        {/* <p>{item.description}</p> */}
                                        {/* <Button to={`/product-details/${item._id}`} label='VIEW PRODUCTS' /> */}
                                    </div>
                                </Col>
                            );

                            return (
                                <div className='home_product_list' key={item._id}>
                                    <Row>
                                        {isEven ? (
                                            <>
                                                {imageCol}
                                                {contentCol}
                                            </>
                                        ) : (
                                            <>
                                                {contentCol}
                                                {imageCol}
                                            </>
                                        )}
                                    </Row>
                                </div>
                            );
                        })
                    ) : (
                        <p></p>
                    )}
                </Container>
            </div>

            <div style={{ paddingBottom: '50px', }}>
                <TextBackground
                    text="powerman"
                    imageUrl={POWORMAIN}
                    className="elgi-text"
                />

                <TextBackground
                    text="india"
                    imageUrl={POWORMAIN}
                    style={{ fontSize: '8em', fontWeight: 700 }}
                />
            </div>

            {/* <GlobalFootprintSection /> */}
            <GlobalFootprintStats />
            <div className='home_banner_section'>
                <div className='home_banner__400'>
                    <Container>
                        <div className='home_banner__400_content'>
                            <h1>A RANGE OF OVER 100+ <span>PRODUCTS TO SUIT</span> YOUR REQUIREMENTS</h1>
                        </div>
                    </Container>
                    <div className='home_banner__400_bg'>
                        <img src={bgIMG} />
                    </div>
                </div>
            </div>

            <div className='home_product border_buttom'>
                <Container>
                    <div className='home_product_list'>
                        <Row>
                            {/* Image Column */}
                            <Col>
                                <div
                                    className="home_product_list_img"
                                    style={{
                                        width: '100%',
                                        maxWidth: '400px', // optional: control image max width
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: '0 110px ',
                                    }}
                                >
                                    <img
                                        src={POWORMAINSTATIC}
                                        alt="Your Product Name"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'contain', // ensures image fits without cropping
                                        }}
                                    />
                                </div>

                            </Col>

                            {/* Content Column */}
                            <Col>
                                <div className='home_product_list_content' style={{ marginRight: '30px' }}>
                                    <h3>Driven by power, built for reliability — Powerman Reciprocating Compressor</h3>

                                    {/* Optional HTML description (you can keep it or write plain text) */}
                                    <p>
                                        Powerman Reciprocating Compressors are designed to deliver consistent performance with high efficiency and durability. Built with robust engineering, these compressors are ideal for applications requiring reliable compressed air under tough working conditions. With advanced technology, easy maintenance, and long service life, Powerman reciprocating compressors ensure smooth operations for workshops, industries, and manufacturing units. They combine power, quality, and efficiency to meet your air needs with confidence.
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>

            <div className='home_product border_buttom'>
                <Container className='home_product_grid_6'>
                    <div className='home_product_list'>
                        <Col>
                            <Row>
                                <>

                                    <Col>
                                        <div className='home_product_list_img'
                                            style={{
                                                width: '100%',
                                                maxWidth: '400px', // optional: control image max width
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                margin: '0 20px',
                                            }}
                                        >
                                            <img
                                                src={POWORMAINSTATIC2}
                                                alt='Product 1'
                                                style={{
                                                    width: '100%',
                                                    height: 'auto',
                                                    objectFit: 'contain', // ensures image fits without cropping
                                                }}
                                            />
                                        </div>
                                    </Col>

                                    {/* Content */}
                                    <Col>
                                        <div className='home_product_list_content'>
                                            <h3>Power man— Power of Clean, Promise of Shine </h3>
                                            <p>The POWERMAN series of reciprocating pumps are designed with advanced engineering techniques to fulfill the most exacting requirements of contemporary users. They bear a fine reputation for both quality and reliability as well as minimum maintenance and service. POWERMAN reciprocating pumps find extensive use in service stations, garages, boiler feeders, steel mills, hydraulic presses, mining breweries, spraying, food processing and numerous other applications.</p>
                                        </div>
                                    </Col>
                                </>
                            </Row>
                        </Col>
                    </div>

                    {/* 🔹 Second Product Block (index = 1 => isEven = false) */}
                    <div className='home_product_list'>
                        <Col>
                            <Row>
                                <>
                                    {/* Content First */}
                                    <Col>
                                        <div className='home_product_list_content'>
                                            <h3>Powerman — Power in Clean, Perfection in Quality</h3>
                                            <p>The POWERMAN series of reciprocating pumps are designed with advanced engineering techniques to fulfill the most exacting requirements of contemporary users. They bear a fine reputation for both quality and reliability as well as minimum maintenance and service. POWERMAN reciprocating pumps find extensive use in service stations, garages, boiler feeders, steel mills, hydraulic presses, mining breweries, spraying, food processing and numerous other applications.</p>
                                        </div>
                                    </Col>

                                    {/* Image */}
                                    <Col>
                                        <div
                                            style={{
                                                width: '100%',
                                                maxWidth: '500px', // optional: control image max width
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                margin: '0 20px',
                                            }}>
                                            <img
                                                src={HOMESTATIC_IMG1}
                                                alt='Product 2'
                                                style={{
                                                    width: '100%',
                                                    height: 'auto',
                                                    objectFit: 'contain', // ensures image fits without cropping
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </>
                            </Row>
                        </Col>
                    </div>
                </Container>
            </div>

            <div className='home_product border_buttom'>
                <Container>
                    <div className='home_product_list'>
                        <Row>
                            {/* Image Column */}
                            <Col>
                                <div className='home_product_list_img'
                                    style={{
                                        width: '100%',
                                        maxWidth: '650px', // optional: control image max width
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: '0 60px',
                                    }}>
                                    <img
                                        src={POWORMAINSTATIC4} // ✅ your manual image path here
                                        alt="Your Product Name"
                                        className='Powerman_four'
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'contain', // ensures image fits without cropping
                                        }}
                                    />
                                </div>
                            </Col>

                            <Col>
                                <div className='home_product_list_content'>
                                    <h3>Accuracy in Every Align – That's the PowerMan Promise</h3>

                                    <p>
                                        Powerman Wheel Aligner brings precision, performance, and reliability to every drive. Designed with advanced technology, it ensures perfect alignment for smoother handling, improved fuel efficiency, and longer tire life. With easy operation and smart features, Powerman makes alignment simple, accurate, and time-saving. Built for workshops that demand speed and perfection, Powerman Wheel Aligner is the trusted choice for powering every journey with safety and confidence.
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>

            <div className='home_product border_buttom'>
                <Container className='home_product_grid_6'>
                    <div className='home_product_list'>
                        <Col>
                            <Row>
                                <>

                                    <Col>
                                        <div className='home_product_list_img'
                                            style={{
                                                width: '100%',
                                                maxWidth: '400px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                margin: '0 auto',
                                            }}
                                        >
                                            <img
                                                src={POWORMAINSTATIC5}
                                                alt='Product 1'
                                                style={{
                                                    width: '100%',
                                                    height: '300px',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>
                                    </Col>


                                    <Col>
                                        <div className='home_product_list_content'>
                                            <h3>Powerman— Smart Change, Smooth Ride</h3>
                                            <p>Powerman Tyre Changers is built for speed, strength, and precision. It makes tyre changing effortless with smooth operation and reliable performance. Designed to save time and reduce effort, Powerman ensures every change is quick and accurate. For workshops that demand efficiency and quality, Powerman Tyre Changer delivers the perfect blend of power and simplicity.</p>
                                        </div>
                                    </Col>
                                </>
                            </Row>
                        </Col>
                    </div>


                    <div className='home_product_list'>
                        <Col>
                            <Row>
                                <>

                                    <Col>
                                        <div className='home_product_list_content'>
                                            <h3>Powerman— Perfect Balance, Perfect Drive</h3>
                                            <p>Experience smooth performance with the Powerman Wheel Balancer, designed for precision, durability, and effortless operation. Its advanced technology ensures every wheel is perfectly balanced, reducing vibrations, improving tyre life, and enhancing vehicle safety. Ideal for workshops and industries, Powerman delivers fast, accurate results, keeping every drive stable and comfortable. With easy controls and powerful performance, it’s the trusted choice for professionals who demand reliability and perfection in every spin, ensuring a flawless ride every time.</p>
                                        </div>
                                    </Col>

                                    <Col>
                                        <div className='home_product_list_img'
                                            style={{
                                                width: '100%',
                                                maxWidth: '400px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                margin: '0 auto',
                                            }}
                                        >
                                            <img
                                                src={POWORMAINSTATIC6}
                                                alt='Product 2'
                                                style={{
                                                    width: '100%',
                                                    height: '300px',
                                                    objectFit: 'contain', // ensures image fits without cropping
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </>
                            </Row>
                        </Col>
                    </div>
                </Container>
            </div>

            <div className='home_product border_buttom'>
                <Container>
                    <div className='home_product_list'>
                        <Row>

                            <Col>
                                <div className='home_product_list_img'
                                    style={{
                                        width: '100%',
                                        maxWidth: '400px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: '0 40px',
                                    }}
                                >
                                    <img
                                        src={HOMESTATIC_IMG7}
                                        alt="Your Product Name"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>
                            </Col>


                            <Col>
                                <div className='home_product_list_content'>
                                    <h3>Powerman — Engineered for Excellence in Automated Car Cleaning</h3>

                                    <p>
                                        Experience the perfect blend of power, precision, and innovation with the Powerman Automatic Car Washer. Designed to deliver spotless results in record time, this system offers a fully automated, touch-free cleaning solution that saves water, energy, and labor—making it the smarter way to clean vehicles in the modern automotive industry.
                                    </p>

                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>


            <div className='home_product border_buttom'>
                <Container className='home_product_grid_6'>
                    <div className='home_product_list'

                    >
                        <Col>
                            <Row>
                                <>

                                    <Col>
                                        <div className='home_product_list_img'
                                            style={{
                                                width: '100%',
                                                maxWidth: '400px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                margin: '0 auto',
                                            }}
                                        >
                                            <img
                                                src={HOMESTATIC_IMG9}
                                                alt='Product 1'
                                                style={{
                                                    width: '80%',
                                                    height: 'auto',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>
                                    </Col>

                                    <Col>
                                        <div className='home_product_list_content'>
                                            <h3> Powerman Air Dryer – The Power Behind Pure Compressed Air </h3>
                                            <p>Experience superior air quality with the Powerman Air Dryer—a perfect blend of innovation and reliability. Designed to deliver consistent, moisture-free air, it enhances system performance, reduces maintenance downtime, and extends equipment life. Powerman’s commitment to quality and technology ensures you get air that’s clean, dry, and ready for any industrial challenge</p>
                                        </div>
                                    </Col>
                                </>
                            </Row>
                        </Col>
                    </div>


                    <div className='home_product_list'>
                        <Col>
                            <Row>
                                <>

                                    <Col>
                                        <div className='home_product_list_content'>
                                            <h3>Advanced Vacuum Technology for Professional Cleaning Needs</h3>
                                            <p>Experience unmatched cleaning power with the Powerman Vacuum Cleaner—a perfect blend of technology, performance, and reliability. Designed to tackle dust, dirt, and debris with ease, it delivers spotless results every time. From industrial floors to workshop corners, Powerman ensures professional-grade cleaning with power you can trust.</p>
                                        </div>
                                    </Col>


                                    <Col>
                                        <div className='home_product_list_img'
                                            style={{
                                                width: '100%',
                                                maxWidth: '400px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                margin: '0 auto',
                                            }}
                                        >
                                            <img
                                                src={HOMESTATIC_IMG9}
                                                alt='Product 2'
                                                style={{
                                                    width: '85%',
                                                    height: 'auto',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </>
                            </Row>
                        </Col>
                    </div>
                </Container>
            </div>



            <FloatingVideoAd videoUrl={shot1} isYouTube={false} />
            <LogoSlider />

        </>
    )
}

export default Home
